export const CURRENCY = {
  UAH: 'uah',
  USD: 'usd',
};

export const isCurrencyUsd = (currency) => currency === CURRENCY.USD;

export const getCurrencyLabel = (currency) => isCurrencyUsd(currency) ? '$' : 'грн';
